(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('countriesController', countriesController)
        .controller('newCountryController', newCountryController)
        .controller('editCountryController', editCountryController)
        .controller('deleteCountryController', deleteCountryController);

    countriesController.$inject = ['linkService', 'tabs', 'countries'];

    newCountryController.$inject = ['tabs', 'continents', 'countryService', 'regexService'];

    editCountryController.$inject = ['tabs', 'continents', 'country', 'countryService', '$stateParams'];

    deleteCountryController.$inject = ['countryId', 'country', 'countryService', '$uibModalInstance'];

    function countriesController(linkService, tabs, countries){
        var vm = this;

        vm.pages = [];
        vm.tabs = tabs;

        vm.countries = (countries.data._embedded.countries) ? countries.data._embedded.countries : [];
        vm.linkService = linkService;
        vm.pages = countries.data.page;

        vm.links = countries.data._links;
    }

    function newCountryController(tabs, continents, countryService, regexService){
        var vm = this;
        vm.tabs = tabs;
        vm.country = {
            active: false
        };
        vm.continents = continents;
        vm.alphanumeric = regexService.alphanumeric;

        vm.saveCountry = function(isValid, country){
            if (isValid) {
                countryService.saveCountry(country)
                    .then(function(){
                        messageService.register('countries');
                    }, function(){
                        messageService.registerError('countries');
                    });
            }
        }
    }

    function editCountryController(tabs, continents, country, countryService, $stateParams){
        var vm = this;
        vm.countryId = $stateParams.id;
        vm.country = country.data;
        vm.tabs = tabs;
        vm.continents = continents;
        vm.country = {
            continent: country.data._embedded.continent.code,
            name: country.data.name,
            initial: country.data.initial,
            iata: country.data.iata,
            active: country.data.active
        };
        vm.old = angular.copy(vm.country);
        vm.buttonSave = true;

        vm.saveCountry = function (isValid, country){
            if (isValid) {
                countryService.updateCountry(vm.countryId, country);
            }
        }

        vm.change = function(){
            if(vm.country.continent==vm.old.continent && vm.country.name.toUpperCase()==vm.old.name.toUpperCase() &&
                vm.country.initial==vm.old.initial && vm.country.iata==vm.old.iata && vm.country.active==vm.old.active){
                vm.buttonSave = true;
            }else{
                vm.buttonSave = false;
            }
        }
    }

    function deleteCountryController(countryId, country, countryService, $uibModalInstance){
        var vm = this;
        vm.country = country.data;

        vm.deleteCountry = function(){
            countryService.deleteCountry(countryId)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
